import React from 'react';
import { BrowserRouter as Router, Link } from "react-router-dom";
import email from '../assets/imgs/email.png';

 function Footer(props) {

   const title1 = 'Contáctanos'
  const title2 = 'Regulations'
  const privacidad = '< Acuerdo de Privacidad >'
  const terminos = '< Acuerdo de Servicio >'
  const emailUrl = 'service@pagolap.com'
  const privacidadUri = '/acuerdoPolitica'
  const terminosUri = '/acuerdoTerminos'  

 

 
  if(props.isMobile) {
    return (
      <footer id="footer" className="footer-mobile">
         <div className="one-center">
          <div className='title'>{title2}</div>
          
          <Router>
            <div className='infos' >
            <Link to={privacidadUri} target="_blank">
            {privacidad}
            </Link>
            </div>
            <div className='infos'>
            <Link to={terminosUri} target="_blank">{terminos}</Link>
            </div>
          </Router>
        </div>
        <div className="one-center-end">
             
            <div className='title'>{title1}</div>
            <div className='infos'>
              <div><img src={email} alt='email'/>{emailUrl}</div>
            </div>
          </div>
     
    </footer>
    )
  }
  return (
    <div id="footer" className={'footer'}>
      <div className="bar">
        <div className="barContent">
        <div className="one-center">
            <div className='title'>{title1}</div>
              <div className='infos'>
                <div><img src={email} alt='email'/>{emailUrl}</div>
              </div>
        </div>
        <div className="one-center">
            <div className='title'>{title2}</div>
              <Router>
                <div className='infos' >
                  <Link to={privacidadUri} target="_blank">
                  <div>{privacidad}</div>
                  </Link>
                  <Link to={terminosUri} target="_blank">
                  
                  <div className='linkEnd'>{terminos}</div>
                  </Link>
                </div>
              </Router>
            </div>
        </div>
      </div>
      <div className="bottom-bar">
          Copyright © 2024 | PagoLap | All Rights Reserved
        </div>
    </div>
  );
}


export default Footer;
